import { useQuery } from '@tanstack/react-query';

const API_BASE_URL = import.meta.env.VITE_API_URL;

interface Product {
  id: number;
  [key: string]: unknown;
}

interface UserProductsResponse {
  data: Product[];
}

const fetchUserProducts = async (): Promise<Product[]> => {
  const response = await fetch(`${API_BASE_URL}/services/myProducts`, {
    method: 'GET',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(`HTTP ${response.status}: ${errorText}`);
  }

  const result: UserProductsResponse = await response.json();
  return result.data ?? [];
};

export const userProductsQueryKey = () => ['user-products'] as const;

export const useUserProductsQuery = () => {
  return useQuery({
    queryKey: userProductsQueryKey(),
    queryFn: () => fetchUserProducts(),
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: false,
  });
};
